module.exports = {
    pleaseLogin: {
        'zh-CN': '您好，请登录',
        'zh-TW': '您好，請登錄',
        'en-US': 'Login',
        'th-TH': 'ล็อกอิน',
        'vi-VN': 'Hãy đăng nhập'
    },
    register: {
        'zh-CN': '注册账号',
        'zh-TW': '註冊帳號',
        'en-US': 'Register',
        'th-TH': 'การลงทะเบียน',
        'vi-VN': 'Đăng ký'
    },
    userRegister: {
        'zh-CN': '注册',
        'zh-TW': '註冊',
        'en-US': 'Register',
        'th-TH': 'ลงทะเบียนทันที',
        'vi-VN': 'Đăng ký'
    },
    login: {
        'zh-CN': '登录',
        'zh-TW': '登錄',
        'en-US': 'Sign in',
        'th-TH': 'ล็อกอินบัญชี',
        'vi-VN': 'Đăng nhập'
    },
    loginEgAccount: {
        'zh-CN': '登录账号',
        'zh-TW': '登錄賬號',
        'en-US': 'Sign in',
        'th-TH': 'ล็อกอินบัญชี',
        'vi-VN': 'Đăng nhập'
    },
    rememberAccount: {
        'zh-CN': '记住账号',
        'zh-TW': '記住賬號',
        'en-US': 'Remember me',
        'th-TH': 'จำบัญชี',
        'vi-VN': 'Ghi nhớ tài khoản'
    },
    captchaCodeError: {
        'zh-CN': '验证码错误',
        'zh-TW': '驗證碼錯誤',
        'en-US': 'Captcha error',
        'th-TH': 'รหัสยืนยันผิด',
        'vi-VN': 'Lỗi mã xác nhận'
    },
    inputAccount: {
        'zh-CN': '请输入账号',
        'zh-TW': '請輸入賬號',
        'en-US': 'Please enter account',
        'th-TH': 'โปรดกรอกบัญชี',
        'vi-VN': 'Nhập Tài Khoản'
    },
    inputPassword: {
        'zh-CN': '请输入密码',
        'zh-TW': '請輸入密碼',
        'en-US': 'Please enter password',
        'th-TH': 'โปรดกรอกรหัส',
        'vi-VN': 'Nhập mật khẩu'
    },
    inputCaptcha: {
        'zh-CN': '请输入验证码',
        'zh-TW': '請輸入驗證碼',
        'en-US': 'Please enter captcha',
        'th-TH': 'โปรดกรอกรหัสยืนยัน',
        'vi-VN': 'Nhận mã xác nhận'
    },
    logout: {
        'zh-CN': '退出',
        'zh-TW': '退出',
        'en-US': 'Logout',
        'th-TH': 'ออก',
        'vi-VN': 'Đăng xuất'
    },
    egPoint: {
        'zh-CN': 'EG点',
        'zh-TW': 'EG點',
        'en-US': 'EG Points',
        'th-TH': 'แต้มEG',
        'vi-VN': 'Điểm EG'
    },
    rewardEgPoint: {
        'zh-CN': '奖励EG点',
        'zh-TW': '奖励EG點',
        'en-US': 'Reward EG Points',
        'th-TH': 'แต้มEG',
        'vi-VN': 'Điểm EG'
    },
    buyGoods: {
        'zh-CN': '购买商品',
        'zh-TW': '購買商品',
        'en-US': 'Purchase',
        'th-TH': 'ซื้อสินค้า',
        'vi-VN': 'Mua hàng'
    },
    egRecharge: {
        'zh-CN': 'EG点充值',
        'zh-TW': 'EG點充值',
        'en-US': 'EG Recharge',
        'th-TH': 'แต้มEGเติมเงิน',
        'vi-VN': 'Nạp điểm EG'
    },
    consumeRecords: {
        'zh-CN': '商品交易记录',
        'zh-TW': '商品交易記錄',
        'en-US': 'Transaction Records',
        'th-TH': 'บันทึกการซื้อของ',
        'vi-VN': 'Lịch sử mua hàng'
    },
    rechargeRecords: {
        'zh-CN': 'EG点充值记录',
        'zh-TW': 'EG點充值記錄',
        'en-US': 'Recharge Records',
        'th-TH': 'บันทึกเติมแต้มEG',
        'vi-VN': 'Kỷ lục Recharge điểm EG'
    },
    noGames: {
        'zh-CN': '暂无可用的游戏',
        'zh-TW': '暫無可用的遊戲',
        'en-US': 'No games available',
        'th-TH': 'ยังไม่มีเกมเล่นได้',
        'vi-VN': 'không có trò chơi'
    },
    noGoods: {
        'zh-CN': '该游戏暂无商品',
        'zh-TW': '該遊戲暫無商品',
        'en-US': 'No goods available',
        'th-TH': 'เกมนี้ยังไม่มีสินค้า',
        'vi-VN': 'Không có hàng'
    },
    statusAll: {
        'zh-CN': '所有订单',
        'zh-TW': '所有訂單',
        'en-US': 'All',
        'th-TH': 'ใบสั่งทั้งหมด',
        'vi-VN': 'Tất cả đơn hàng'
    },
    statusPending: {
        'zh-CN': '支付中',
        'zh-TW': '支付中',
        'en-US': 'Pending',
        'th-TH': 'ชำระอยู่',
        'vi-VN': 'Đang thanh toán'
    },
    statusSuccess: {
        'zh-CN': '已完成',
        'zh-TW': '已完成',
        'en-US': 'Success',
        'th-TH': 'สำเร็จแล้ว',
        'vi-VN': 'Đã hoàn thành'
    },
    statusFail: {
        'zh-CN': '已失败',
        'zh-TW': '已失敗',
        'en-US': 'Failed',
        'th-TH': 'ล้มเหลว',
        'vi-VN': 'Thất bại'
    },
    orderDate: {
        'zh-CN': '订单时间',
        'zh-TW': '訂單時間',
        'en-US': 'Order Date',
        'th-TH': 'เวลาใบสั่ง',
        'vi-VN': 'Ngày đặt hàng'
    },
    search: {
        'zh-CN': '查询',
        'zh-TW': '查詢',
        'en-US': 'Search',
        'th-TH': 'ตรวจ',
        'vi-VN': 'Kiểm tra'
    },
    selectDateRange: {
        'zh-CN': '选择日期范围',
        'zh-TW': '選擇日期範圍',
        'en-US': 'Select Date Range',
        'th-TH': 'เลือกขอบเขตเวลา',
        'vi-VN': 'Chọn phạm vi ngày'
    },
    selectChannel: {
        'zh-CN': '请选择支付方式',
        'zh-TW': '請選擇支付方式',
        'en-US': 'Select payment method',
        'th-TH': 'เลือกวิธีชำระ',
        'vi-VN': 'Hãy chọn phương thức thanh toán'
    },
    selectChannelNew: {
        'zh-CN': 'LunaM預註冊點卡兌換',
        'zh-TW': 'LunaM預註冊點卡兌換',
        'en-US': 'LunaM pre-registration point card exchange',
        'th-TH': 'LunaM pre-registration point card exchange',
        'vi-VN': 'Trao đổi thẻ đăng ký trước LunaM'
    },
    purchase: {
        'zh-CN': '购买',
        'zh-TW': '購買',
        'en-US': 'Purchase',
        'th-TH': 'ซื้อ',
        'vi-VN': 'Mua'
    },
    changeCaptcha: {
        'zh-CN': '看不清，换一张',
        'zh-TW': '看不清，換一張',
        'en-US': 'Unclear? Another one',
        'th-TH': 'เห็นไม่ชัด เปลี่ยนอื่น',
        'vi-VN': 'Nhìn không rõ, thay đổi một'
    },
    recordDate: {
        'zh-CN': '交易时间',
        'zh-TW': '交易時間',
        'en-US': 'Exchange Date',
        'th-TH': 'เวลาซื้อขาย',
        'vi-VN': 'Thời gian đặt hàng'
    },
    appName: {
        'zh-CN': '应用名称',
        'zh-TW': '應用名稱',
        'en-US': 'App Name',
        'th-TH': 'ชื่อApp',
        'vi-VN': 'Tên ứng dùng'
    },
    goodsName: {
        'zh-CN': '商品名称',
        'zh-TW': '商品名稱',
        'en-US': 'Goods Name',
        'th-TH': 'ชื่อสินค้า',
        'vi-VN': 'Tên hàng'
    },
    goodsPrice: {
        'zh-CN': '商品价格',
        'zh-TW': '商品價格',
        'en-US': 'Goods Price',
        'th-TH': 'ราคาสินค้า',
        'vi-VN': 'Giá hàng'
    },
    orderId: {
        'zh-CN': '订单号',
        'zh-TW': '訂單號',
        'en-US': 'Order ID',
        'th-TH': 'IDใบสั่ง',
        'vi-VN': 'Số đơn hàng'
    },
    orderStatus: {
        'zh-CN': '订单状态',
        'zh-TW': '訂單狀態',
        'en-US': 'Order Status',
        'th-TH': 'สภาพใบสั่ง',
        'vi-VN': ' Trạng thái đơn hàng'
    },
    rechargeChannel: {
        'zh-CN': '充值渠道',
        'zh-TW': '儲值渠道',
        'en-US': 'Pay Channel',
        'th-TH': 'ช่องทางเติมเงิน',
        'vi-VN': 'Kênh nạp thẻ'
    },
    rechargeAmount: {
        'zh-CN': '充值金额',
        'zh-TW': '儲值金額',
        'en-US': 'Amount',
        'th-TH': 'จำนวนเติมเงิน',
        'vi-VN': 'Mệnh giá nạp'
    },
    confirmOrder: {
        'zh-CN': '订单确认',
        'zh-TW': '訂單確認',
        'en-US': 'Confirm Order',
        'th-TH': 'ยืนยันใบสั่ง',
        'vi-VN': 'Xác nhận'
    },
    gameArea: {
        'zh-CN': '游戏大区',
        'zh-TW': '遊戲大廳',
        'en-US': 'Game Area',
        'th-TH': 'เขต',
        'vi-VN': 'Khu vực game'
    },
    gameServer: {
        'zh-CN': '游戏区服',
        'zh-TW': '遊戲區服',
        'en-US': 'Game Server',
        'th-TH': 'โซน',
        'vi-VN': 'Máy chủ'
    },
    roleName: {
        'zh-CN': '角色名称',
        'zh-TW': '角色名稱',
        'en-US': 'Character Name',
        'th-TH': 'ชื่อตัวละคร',
        'vi-VN': 'Tên nhân vật'
    },
    loginPassword: {
        'zh-CN': '登录密码',
        'zh-TW': '登錄密碼',
        'en-US': 'Login Password',
        'th-TH': 'รหัสล็อกอิน',
        'vi-VN': 'Mật khẩu'
    },
    confirmBuy: {
        'zh-CN': '确定购买',
        'zh-TW': '確定購買',
        'en-US': 'Confirm',
        'th-TH': 'ยืนยันซื้อ',
        'vi-VN': 'xác nhận'
    },
    cancelBuy: {
        'zh-CN': '取消购买',
        'zh-TW': '取消購買',
        'en-US': 'Cancel',
        'th-TH': 'ยกเลิก',
        'vi-VN': 'Hủy'
    },
    areaAsia: {
        'zh-CN': '亚太',
        'zh-TW': '亞太',
        'en-US': 'Asia Oceania',
        'th-TH': 'เอเชียแปซิฟิก',
        'vi-VN': 'Đông Nam Á'
    },
    areaAmerica: {
        'zh-CN': '北美/南美',
        'zh-TW': '北美/南美',
        'en-US': 'North America/South America',
        'th-TH': 'อเมริกาเหนือ/อเมริกาใต้',
        'vi-VN': 'Bắc/Nam Mỹ'
    },
    areaEurope: {
        'zh-CN': '欧洲/非洲',
        'zh-TW': '歐洲/非洲',
        'en-US': 'Europe/Africa',
        'th-TH': 'ยุโรป/แอฟริกา',
        'vi-VN': 'Châu Âu/ Châu Phi'
    },
    selectGameServer: {
        'zh-CN': '请选择游戏区服',
        'zh-TW': '請選擇遊戲區服',
        'en-US': 'Select game server',
        'th-TH': 'กรุณาเลือกโซน',
        'vi-VN': 'Chọn Khu vực'
    },
    use: {
        'zh-CN': '用',
        'zh-TW': '用',
        'en-US': 'Use ',
        'th-TH': 'ใช้',
        'vi-VN': 'Sử dùng'
    },
    buyEgPoint: {
        'zh-CN': '购买EG点',
        'zh-TW': '購買EG點',
        'en-US': ' Buy EG Points',
        'th-TH': 'ซื้อแต้มEG',
        'vi-VN': 'Mua điểm EG'
    },
    cardNo: {
        'zh-CN': '卡号',
        'zh-TW': '卡號',
        'en-US': 'Card',
        'th-TH': 'การ์ด',
        'vi-VN': 'Số thẻ'
    },
    serialNo: {
        'zh-CN': '序列号',
        'zh-TW': '序列號',
        'en-US': 'Serial',
        'th-TH': 'ซีเรียล',
        'vi-VN': 'Số xê ri'
    },
    cardNotEmpty: {
        'zh-CN': '卡号不能为空',
        'zh-TW': '卡號不能為空',
        'en-US': 'Card is needed',
        'th-TH': 'การ์ดเป็นช่องว่างไม่ได้',
        'vi-VN': 'Số thể không được để trống'
    },
    serialNotEmpty: {
        'zh-CN': '序列号不能为空',
        'zh-TW': '序列號不能為空',
        'en-US': 'Serial is needed',
        'th-TH': 'ซีเรียลเป็นช่องว่างไม่ได้',
        'vi-VN': 'Số xê ri không được để trống'
    },
    selectCurrency: {
        'zh-CN': '请选择币种',
        'zh-TW': '請選擇幣種',
        'en-US': 'Select currency',
        'th-TH': 'โปรดเลือกสกุลเงิน',
        'vi-VN': 'Chọn loại tiền tệ'
    },
    rechargeSuccess: {
        'zh-CN': '充值成功',
        'zh-TW': '儲值成功',
        'en-US': 'Recharge Success',
        'th-TH': 'เติมเงินสำเร็จ',
        'vi-VN': 'Thanh toán thành công'
    },
    rechargeSuccessAmount: {
        'zh-CN': '成功充值',
        'zh-TW': '成功儲值',
        'en-US': 'Recharge Success：',
        'th-TH': 'สำเร็จเติมเงิน',
        'vi-VN': 'Thanh toán thành công'
    },
    rechargeFinish: {
        'zh-CN': '充值完成',
        'zh-TW': '儲值完成',
        'en-US': 'Recharge Finish',
        'th-TH': 'เติมเงินเสร็จแล้ว',
        'vi-VN': 'Hoàn thành'
    },
    rechargeFinishCheckLater: {
        'zh-CN': '充值完成，请稍后查询充值结果',
        'zh-TW': '儲值完成，請稍後查詢儲值結果',
        'en-US': 'Recharge finish, check recharge result later',
        'th-TH': 'เติมเงินเสร็จแล้ว โปรดตรวจผลทีหลัง',
        'vi-VN': 'Bạn đã thanh toán thành công,vui lòng một lát nữa kiểm tra kết quả nạp tiền.'
    },
    rechargeCancel: {
        'zh-CN': '充值取消',
        'zh-TW': '儲值取消',
        'en-US': 'Recharge Cancel',
        'th-TH': 'ยกเลิกเติมเงิน',
        'vi-VN': 'Hủy thanh toán '
    },
    rechargeCancelQuestAgain: {
        'zh-CN': '充值取消，如需充值请再次发起请求',
        'zh-TW': '儲值取消，如需儲值請再次發起請求',
        'en-US': 'Recharge canceled, try again',
        'th-TH': 'ยกเลิกเติมเงิน ถ้าอยากเติมเงินกรุณาลองใหม่',
        'vi-VN': 'thanh toán bị hủy. Nếu bạn cần nạp vui lòng thử lại.'
    },
    rechargeFail: {
        'zh-CN': '充值失败',
        'zh-TW': '儲值失敗',
        'en-US': 'Recharge Fail',
        'th-TH': 'เติมเงินล้มเหลว',
        'vi-VN': 'thanh toán thất bại'
    },
    rechargeFailErrCode: {
        'zh-CN': '充值失败，错误码为：',
        'zh-TW': '儲值失敗，錯誤碼為：',
        'en-US': 'Recharge fail, error code: ',
        'th-TH': 'เติมเงินล้มเหลว codeคือ:',
        'vi-VN': 'thanh toán thất bại,Mã lỗi là:'
    },
    createOrderFail: {
        'zh-CN': '创建订单失败',
        'zh-TW': '創建訂單失敗',
        'en-US': 'Create Order Fail',
        'th-TH': 'สร้างใบสั่งล้มเหลว',
        'vi-VN': 'Tạo đơn hàng thất bại'
    },
    createOrderFailTryAgain: {
        'zh-CN': '订单创建失败，请稍后再试',
        'zh-TW': '創建訂單失敗，請稍後再試',
        'en-US': 'Create order fail, try again later',
        'th-TH': 'สร้างใบสั่งล้มเหลว กรุณาลองใหม่ทีหลัง',
        'vi-VN': 'Tạo đơn hàng thất bại, hãy thử lại'
    },
    systemError: {
        'zh-CN': '系统错误',
        'zh-TW': '系統錯誤',
        'en-US': 'System Error',
        'th-TH': 'ระบบผิดพลาด',
        'vi-VN': 'Lỗi hệ thống'
    },
    systemErrorTryLater: {
        'zh-CN': '系统错误，请稍后再试',
        'zh-TW': '系統錯誤，請稍後再試',
        'en-US': 'System error, try again later',
        'th-TH': 'ระบบผิดพลาด กรุณาลองใหม่ทีหลัง',
        'vi-VN': 'Lỗi hệ thống, hãy thử lại'
    },
    confirm: {
        'zh-CN': '确定',
        'zh-TW': '確定',
        'en-US': 'Confirm',
        'th-TH': 'ยืนยัน',
        'vi-VN': 'Xác nhận'
    },
    noRoleInServer: {
        'zh-CN': '您在该服务器上无角色',
        'zh-TW': '您在該服務器上無角色',
        'en-US': 'No character in the server',
        'th-TH': 'โซนนี้ไม่มีตัวละคร',
        'vi-VN': 'Không có vai trò'
    },
    getRoleFail: {
        'zh-CN': '获取角色信息失败',
        'zh-TW': '獲取角色信息失敗',
        'en-US': 'Get character fail',
        'th-TH': 'ได้ข้อมูลตัวละครล้มเหลว',
        'vi-VN': 'Không thể lấy thông tin vai trò'
    },
    noRoleMsg: {
        'zh-CN': '无角色',
        'zh-TW': '无角色',
        'en-US': 'no role',
        'th-TH': 'ไม่มีบทบาท',
        'vi-VN': 'Không có vai trò'
    },
    getServerFail: {
        'zh-CN': '获取服务器列表失败',
        'zh-TW': '獲取服務器列表失敗',
        'en-US': 'Get server list fail',
        'th-TH': 'ได้รายการโซนล้มเหลว',
        'vi-VN': 'Không thể lấy danh sách máy chủ'
    },
    pleaseInputPassword: {
        'zh-CN': '请填写密码',
        'zh-TW': '請填寫密碼',
        'en-US': 'Please enter password',
        'th-TH': 'โปรดกรอกรหัส',
        'vi-VN': 'Nhập mật khẩu'
    },
    createGoodsOrderFail: {
        'zh-CN': '创建订单失败！',
        'zh-TW': '創建訂單失敗！',
        'en-US': 'Create order fail',
        'th-TH': 'สร้างใบสั่งล้มเหลว',
        'vi-VN': 'Tạo đơn hàng thất bại'
    },
    buyGoodsSuccess: {
        'zh-CN': '购买成功！',
        'zh-TW': '購買成功！',
        'en-US': 'Buy goods success',
        'th-TH': 'ซื้อสำเร็จ',
        'vi-VN': 'Thanh toán thành công'
    },
    buyGoodsFail: {
        'zh-CN': '购买失败',
        'zh-TW': '購買失敗',
        'en-US': 'Buy goods fail',
        'th-TH': 'ซื้อล้มเหลว',
        'vi-VN': 'Thanh toán thất bại'
    },
    buyGoodsFailErrorCode: {
        'zh-CN': '购买失败，错误码为：',
        'zh-TW': '購買失敗，錯誤碼為：',
        'en-US': 'Buy goods fail, error code: ',
        'th-TH': 'ซื้อล้มเหลว codeคือ:',
        'vi-VN': 'thanh toán thất bại,Mã lỗi là:'
    },
    networkError: {
        'zh-CN': '网络错误，请稍后再试',
        'zh-TW': '網絡錯誤，請稍後再試',
        'en-US': 'Network error, try again later',
        'th-TH': 'เคลือข่ายล้มเหลว กรุณาลองใหม่ทีหลัง',
        'vi-VN': 'Bạn bị mất kết nối, hãy thử lại'
    },
    nextPage: {
        'zh-CN': '下一页',
        'zh-TW': '下一頁',
        'en-US': 'Next',
        'th-TH': 'หน้าถัดไป',
        'vi-VN': 'Tiếp theo'
    },
    previewPage: {
        'zh-CN': '上一页',
        'zh-TW': '上一頁',
        'en-US': 'Preview',
        'th-TH': 'หน้าก่อนหน้า',
        'vi-VN': 'Trang trước'
    },
    lastWeek: {
        'zh-CN': '最近一周',
        'zh-TW': '最近一周',
        'en-US': 'Last week',
        'th-TH': 'สัปดาห์ที่แล้ว',
        'vi-VN': 'Tuần trước'
    },
    lastMonth: {
        'zh-CN': '最近一个月',
        'zh-TW': '最近一個月',
        'en-US': 'Last month',
        'th-TH': 'เดือนที่แล้ว',
        'vi-VN': 'Tháng trước'
    },
    lastThreeMonth: {
        'zh-CN': '最近三个月',
        'zh-TW': '最近三個月',
        'en-US': 'Last 3 months',
        'th-TH': '3เดือนที่แล้ว',
        'vi-VN': '3 tháng qua'
    },
    noRecords: {
        'zh-CN': '无记录',
        'zh-TW': '無記錄',
        'en-US': 'No Records',
        'th-TH': 'ไม่มีบันทึก',
        'vi-VN': 'Không có hồ sơ'
    },
    downloadGame: {
        'zh-CN': '下载游戏',
        'zh-TW': '下載遊戲',
        'en-US': 'Download Game',
        'th-TH': 'ดาวโหลดเกม',
        'vi-VN': 'Cài đặt'
    },
    passwordError: {
        'zh-CN': '密码错误',
        'zh-TW': '密碼錯誤',
        'en-US': 'Password error',
        'th-TH': 'Password error',
        'vi-VN': 'Sai mật khẩu'
    },
    userNotExits: {
        'zh-CN': '用户名不存在',
        'zh-TW': '用戶名不存在',
        'en-US': 'User not exists',
        'th-TH': 'User not exists',
        'vi-VN': 'Tên đăng nhập không tồn tại'
    },
    egPointNotEnough: {
        'zh-CN': 'EG点数不足',
        'zh-TW': 'EG點數不足',
        'en-US': 'EG point not enough',
        'th-TH': 'EG point not enough',
        'vi-VN': 'Điểm EG không đủ'
    },
    isBlocked: {
        'zh-CN': '此账号已被封禁，如需解禁请联系客服',
        'zh-TW': '此賬號已被封禁，如需解禁請聯繫客服',
        'en-US': 'This account is blocked, please contact CS',
        'th-TH': 'บัญชีของคุณห้ามใช้แล้ว กรุณาติดต่อฝ่ายบริการลูกค้า',
        'vi-VN': 'Tài khoản của bạn đã bị cấm. Nếu bạn cần gỡ bỏ lệnh cấm, vui lòng liên hệ với CSKH.'
    },
    payNow: {
        'zh-CN': '前往支付渠道',
        'zh-TW': '前往支付渠道',
        'en-US': 'Pay now',
        'th-TH': 'ไปสู่ช่องทางชำระ',
        'vi-VN': 'Chuyển đến kênh thanh toán '
    },
    userIsExist: {
        'zh-CN': '该用户名已存在',
        'zh-TW': '該用戶名已存在',
        'en-US': 'User name is already exist',
        'th-TH': 'ชื่อผู้ใช้นี้มีอยู่แล้ว',
        'vi-VN': 'Tên đăng nhập đã tồn tại'
    },
    service: {
        'zh-CN': '服务条款',
        'zh-TW': '服務條款',
        'en-US': 'Service Policy',
        'th-TH': 'รายาการบริการ',
        'vi-VN': 'Điều khoản phục vụ'
    },
    notValid: {
        'zh-CN': '请输入有效的账号和密码',
        'zh-TW': '請輸入有效的賬號和密碼',
        'en-US': 'Please enter valid account and password',
        'th-TH': 'กรุณากรอกบัญชีและรหัสถูกต้อง',
        'vi-VN': 'Hãy nhập tài khoản và mật khẩu chính xác'
    },
    selectService: {
        'zh-CN': '请阅读并同意服务条款',
        'zh-TW': '請閱讀並同意服務條款',
        'en-US': 'Read and accept service policy',
        'th-TH': 'กรุณาอ่านและยืนยันรายาการบริการ',
        'vi-VN': ' Hãy đọc và đồng ý với điều khoản'
    },
    codeError: {
        'zh-CN': '验证码超时',
        'zh-TW': '驗證碼超時',
        'en-US': 'Verification Code Timeout',
        'th-TH': 'รหัสยืนยันหมดอายุ',
        'vi-VN': 'Quá thời gian nhận mã xác nhận'
    },
};



// WEBPACK FOOTER //
// ./src/lang/store.js